import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Close } from "@mui/icons-material";
import { AlertTitle, Fade, IconButton, Alert as MuiAlert, styled, Typography } from "@mui/material";
import { useToggle, useUpdateEffect } from "react-use";
import { useHermes } from "./useHermes";
const Text = styled(Typography)({
    fontSize: 'inherit',
    marginBottom: 0
});
export const Alert = (props)=>{
    const [alert] = useHermes('alert');
    const [open, toggleOpen] = useToggle(!!alert);
    useUpdateEffect(()=>{
        if (!!alert !== open) {
            toggleOpen(!!alert);
        }
    }, [
        alert?.isActive
    ]);
    return /*#__PURE__*/ _jsx(Fade, {
        in: open,
        unmountOnExit: true,
        children: /*#__PURE__*/ _jsxs(MuiAlert, {
            action: alert?.isDismissable && /*#__PURE__*/ _jsx(IconButton, {
                "aria-label": "close",
                color: "inherit",
                size: "small",
                onClick: toggleOpen,
                children: /*#__PURE__*/ _jsx(Close, {
                    fontSize: "inherit"
                })
            }),
            classes: props.classes,
            className: props.className,
            severity: "info",
            children: [
                alert?.title && /*#__PURE__*/ _jsx(AlertTitle, {
                    children: alert.title
                }),
                alert?.description && /*#__PURE__*/ _jsx(Text, {
                    children: alert.description
                })
            ]
        })
    });
};

//# sourceMappingURL=Alert.js.map